import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  boxShadow: 24,
};

export const video: SxStyle = {
  width: '100%',
  display: 'block',
};
